import { Typography, Box } from "@mui/material"
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined"
import UserTable from "layouts/profile/componant/UserTable.tsx"
import { OreveButton } from "components/button/OreveButton.tsx"
import { useNavigate } from "react-router-dom"
import { Loader } from "components/Loader.tsx"
import {
    OrevePopup,
    OrevePopupContent,
    OrevePopupTitle,
} from "components/popup/OrevePopup.tsx"
import { ProfilePageProvider } from "layouts/profile/context/provider.tsx"
import { useProfileContext } from "layouts/profile/context/useProfileContext.ts"

const UserAccountPageContent = () => {
    const navigate = useNavigate()
    const {
        isLoading,
        userProfile,
        clickOnPassword,
        isPasswordPopinOpen,
        setIsPasswordPopinOpen,
        modifyPassword,
    } = useProfileContext()

    const modifiedUserProfile = userProfile.map((row) => ({
        ...row,
        value: row.value !== null ? row.value : "",
    }))

    if (isLoading)
        return (
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    backgroundColor: "#fff",
                    paddingX: "2.25rem",
                    paddingY: "1.5rem",
                    borderRadius: "20px",
                    border: "none",
                }}
            >
                <Loader />
            </Box>
        )

    return (
        <Box
            sx={{
                backgroundColor: "#fff",
                paddingX: "2.25rem",
                paddingY: "1.5rem",
                borderRadius: "20px",
                border: "none",
            }}
        >
            <Typography variant={"headline"}>Mon compte</Typography>
            <UserTable
                userProfile={modifiedUserProfile}
                clickOnPassword={clickOnPassword}
                setIsPasswordPopinOpen={setIsPasswordPopinOpen}
            />
            <OrevePopup
                open={isPasswordPopinOpen}
                handleClose={() => {
                    setIsPasswordPopinOpen(false)
                    modifyPassword()
                }}
            >
                <OrevePopupTitle>
                    <Typography variant={"headlineSmall"}>
                        Demande de modification de mot de passe envoyée
                    </Typography>
                </OrevePopupTitle>
                <OrevePopupContent>
                    <OreveButton
                        variant={"contained"}
                        value={"Retour à l’accueil"}
                        onClick={() => {
                            navigate("/")
                        }}
                        icon={HomeOutlinedIcon}
                        sx={{
                            whiteSpace: "nowrap",
                            "& :first-of-type": {
                                color: "#fff",
                            },
                        }}
                    />
                </OrevePopupContent>
            </OrevePopup>
        </Box>
    )
}

export const UserAccountPage = () => {
    return (
        <ProfilePageProvider>
            <UserAccountPageContent />
        </ProfilePageProvider>
    )
}
